import React, { FC, PropsWithChildren, useCallback, useEffect, useState } from 'react';
import { getCookie, setCookie } from '@next/shared';
import { useLogger } from 'shared/lib/logger';
import { ALLOW_UNSUPPORTED_BROWSER_COOKIE_KEY } from '../config/constants';
import { checkBrowserVersion, getBrowserInfo } from '../lib/check-browser';
import { UnsupportedBrowser } from './UnsupportedBrowser';

export const UnsupportedBrowserGuard: FC<PropsWithChildren> = ({ children }) => {
    const [isShowWarning, setIsShowWarning] = useState(false);
    const { logger } = useLogger();

    const onSkipWarning = useCallback(() => {
        setIsShowWarning(false);
        setCookie(ALLOW_UNSUPPORTED_BROWSER_COOKIE_KEY, String(true));
    }, []);

    useEffect(() => {
        if (getCookie(ALLOW_UNSUPPORTED_BROWSER_COOKIE_KEY) === 'true') {
            return;
        }

        const { browser, version } = getBrowserInfo(navigator.userAgent);

        logger.log('Detected browser', { browser, version });

        if (!browser || !version) {
            setIsShowWarning(true);
            return;
        }

        if (!checkBrowserVersion(browser, version)) {
            setIsShowWarning(true);
        }
    }, []);

    return isShowWarning ? <UnsupportedBrowser onSkipWarning={onSkipWarning} /> : <>{children}</>;
};
